import { Col, Modal, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import { useRef, useState } from "react";

const ViewMaterialType = (props) => {

    const singleMaterialTypeData = props.singleMaterialTypeData;

    return (
        <>
            <Modal show={props.showViewDetails} onHide={props.handleCloseViewModal} className='add-customer-modal add-user-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>View Material Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label className="pb-1 pt-1">Material Type Code </label>
                                        <span>{singleMaterialTypeData[0]?.MaterialTypeCode}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label className="pb-1 pt-1">Material Type Name </label>
                                        <span>{singleMaterialTypeData[0]?.Name}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div className="view-sla-data">
                                        <label> Description </label>
                                        <span>{singleMaterialTypeData[0]?.MaterialTypeDescription}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="view-sla-data">
                                        <label className="pb-1 pt-1"> Status </label>
                                        <span>{singleMaterialTypeData[0]?.Status}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseViewModal} />
                    <SBSaveUpdateBtn btnName="Ok" />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default ViewMaterialType;